
export const RECOMMENDATION_PROMPT = `你是一位亚马逊选品与运营战略顾问。基于用户需求和提供的关键词池，请构建一套完整的关键词运营方案。

# 核心指令
1. **空值处理**：忽略数据为空的指标。
2. **战略分层**：构建"金字塔"结构的关键词组合（塔尖、塔身、塔基）。
3. **结合产品**：优先推荐能体现卖点的关键词。

# 用户需求
- 主要目标: {{user_preference.main_goal}}
- 预算范围: {{user_preference.budget_range}}
- 经验水平: {{user_preference.experience_level}}
- 时间预期: {{user_preference.time_expectation}}
- 补充需求: {{user_preference.custom_requirements}}

{{product_info_section}}

# 关键词摘要数据
{{keywords_summary_json}}

# 输出要求
请严格按照以下 JSON 格式输出（不要添加任何额外文字）。

**战略建议重点**：
1. **阶段性打法**：启动期 vs 爬坡期。
2. **预算分配**：核心词 vs 长尾词。
3. **风险提示**：烧钱风险。

\`\`\`json
{
   "keyword_pyramid": {
      "top_tier": ["核心大词1", "核心大词2"],
         "middle_tier": ["精准长尾词1", "精准长尾词2", "精准长尾词3"],
            "base_tier": ["补充流量词1", "..."]
   },
   "phased_strategy": {
      "launch_phase": {
         "focus_keywords": ["词1", "词2"],
            "tactic": "启动期打法描述"
      },
      "growth_phase": {
         "focus_keywords": ["词3", "词4"],
            "tactic": "爬坡期打法描述"
      }
   },
   "budget_allocation": {
      "head_terms_percentage": 30,
         "long_tail_percentage": 70,
            "reasoning": "分配理由"
   },
   "risk_management": "风险提示与应对"
}
\`\`\`

请返回 JSON 数据。`;
